import { render } from "./ConfirmationElement.vue?vue&type=template&id=56f5c760&ts=true"
import script from "./ConfirmationElement.vue?vue&type=script&lang=ts"
export * from "./ConfirmationElement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__